"use client"; // Error boundaries must be Client Components
import "./style/globals.css";

export default function Error() {
  return (
    <div className="fixed left-0 top-0 size-full flex flex-col justify-center items-center bg-white dark:bg-black">
      <h2>Something went wrong!</h2>
    </div>
  );
}
